export enum MANAGE_MODULES_BUTTONS {
  'stop' = 'stop',
  'restart' = 'restart',
  'remove' = 'remove',
}
